"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Conditions = _interopRequireDefault(require("access-control-lib/conditions/Conditions"));

var _selectors = require("settings-ui-sdk/Routes/selectors");

var _selectors2 = require("settings-ui-sdk/Auth/selectors");

var _UISubheader = _interopRequireDefault(require("UIComponents/layout/UISubheader"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UIRouterTab = _interopRequireDefault(require("ui-addon-react-router/UIRouterTab"));

var _AccessControl = require("../constants/AccessControl");

var _Urls = require("../constants/Urls");

var _SaveChangesContainer = _interopRequireDefault(require("./SaveChangesContainer"));

var FormsContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FormsContainer, _PureComponent);

  function FormsContainer() {
    (0, _classCallCheck2.default)(this, FormsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(FormsContainer, [{
    key: "maybeRenderSaveChanges",
    value: function maybeRenderSaveChanges() {
      var activeTab = this.props.activeTab;

      if (activeTab === _Urls.NON_HUBSPOT_PATH) {
        return null;
      }

      return _react.default.createElement(_SaveChangesContainer.default, null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hasCollectedFormsAccess = _this$props.hasCollectedFormsAccess,
          activeTab = _this$props.activeTab,
          children = _this$props.children;
      return _react.default.createElement("div", {
        className: "m-bottom-10"
      }, _react.default.createElement(_UISubheader.default, {
        tabs: _react.default.createElement(_UITabs.default, {
          use: "enclosed",
          selected: activeTab,
          defaultSelected: _Urls.STYLES_PATH
        }, _react.default.createElement(_UIRouterTab.default, {
          tabId: _Urls.STYLES_PATH,
          to: _Urls.BASE_FORMS_TAB_ROUTE + "/" + _Urls.STYLES_PATH,
          title: _react.default.createElement(_FormattedMessage.default, {
            message: "marketing.forms.tabs.styles"
          })
        }), _react.default.createElement(_UIRouterTab.default, {
          tabId: _Urls.SUBMISSIONS_SETTINGS_PATH,
          to: _Urls.BASE_FORMS_TAB_ROUTE + "/" + _Urls.SUBMISSIONS_SETTINGS_PATH,
          title: _react.default.createElement(_FormattedMessage.default, {
            message: "marketing.forms.tabs.submissionsSettings"
          })
        }), hasCollectedFormsAccess && _react.default.createElement(_UIRouterTab.default, {
          tabId: _Urls.NON_HUBSPOT_PATH,
          to: _Urls.BASE_FORMS_TAB_ROUTE + "/" + _Urls.NON_HUBSPOT_PATH,
          title: _react.default.createElement(_FormattedMessage.default, {
            message: "marketing.forms.tabs.nonHubspot"
          })
        })),
        title: _I18n.default.text('marketing.forms.pageTitle')
      }), children, this.maybeRenderSaveChanges());
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        children: _react.PropTypes.node,
        activeTab: _react.PropTypes.string.isRequired,
        hasCollectedFormsAccess: _react.PropTypes.bool.isRequired
      };
    }
  }]);
  return FormsContainer;
}(_react.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  var scopes = (0, _selectors2.getUserScopes)(state);
  return {
    activeTab: (0, _selectors.getLastURLPathElement)(state),
    hasCollectedFormsAccess: _Conditions.default.shouldAccess(_AccessControl.COLLECTED_FORMS)({
      scopes: scopes
    })
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {})(FormsContainer);

exports.default = _default;
module.exports = exports.default;